/**
 * fetchSessions — tries the live API first, falls back to IndexedDB on any failure.
 */
import { API_BASE_URL, authFetch } from "../config/api";
import { isSyncedDataAvailable } from "./dataFetch";
import { getSessions } from "./offlineQuery";

export async function fetchSessions() {
  // Try the live API first
  try {
    const res = await authFetch(`${API_BASE_URL}/api/sessions/`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const text = await res.text();
    // Guard against HTML error pages being returned
    if (text.trim().startsWith("<"))
      throw new Error("Server returned HTML, not JSON");
    const json = JSON.parse(text);
    if (json.sessions) return json;
    throw new Error("Invalid response");
  } catch (err) {
    // API failed — try IndexedDB
    console.warn("[fetchSessions] API failed, trying IndexedDB:", err.message);
    const hasData = await isSyncedDataAvailable();
    if (!hasData)
      throw new Error(
        "You are offline and no synced data is available. Please sync while online first.",
      );
    return getSessions();
  }
}
